module.exports = __webpack_public_path__ + "img/pic_no_net.c09372b7.png";